import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonGrid, IonRow, IonCol, IonCard, IonCardHeader, IonCardTitle, IonCardContent, IonIcon, IonButton } from '@ionic/react';
import EnvironmentBadge from '../components/EnvironmentBadge';
import ExploreContainer from '../components/ExploreContainer';
import './Home.css';
import { people, documents, person, personCircle, timer, layers, duplicate, logOut, construct, barcodeOutline, cubeOutline, journal, swapHorizontalOutline, settings, water } from 'ionicons/icons'
import React, { useState, useEffect } from 'react';
import { useLocalStorage } from '../components/useLocalStorage'
import axios from "axios";
import getApi from '../api';
import notifications from '../components/Notifications';
import useLogout from '../hooks/useLogout';

const Home: React.FC = () => {

  const [me] = useLocalStorage("me", "");
  const { logout } = useLogout();


  return (
    <IonPage placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
      <IonHeader placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
        <IonToolbar placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} color="primary">
          <IonTitle placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Blekinge Bevattning</IonTitle>
          <div slot="end" style={{ paddingRight: '8px' }}><EnvironmentBadge /></div>
        </IonToolbar>
      </IonHeader>
      <IonContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} fullscreen>
        <IonCard placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonIcon placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} class="icon" icon={personCircle} />
            <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} class="icon-text-main">
              {me.name}
            </IonCardContent>
          </IonCardContent>
        </IonCard>
        <IonHeader placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} collapse="condense">
        </IonHeader>
        <IonGrid placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} size="6">
              <IonCard placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} className="home-card" routerLink="/customers">
                <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                  <IonIcon placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} class="icon" icon={people} />
                  <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} class="icon-text-main">
                    Kunder
                  </IonCardContent>
                </IonCardContent>
              </IonCard>
            </IonCol>
            <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} size="6">
              <IonCard placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} className="home-card" routerLink="/TimeRegistrationV2">
                <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                  <IonIcon placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} class="icon" icon={timer} />
                  <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} class="icon-text-main">
                    Tid V2
                  </IonCardContent>
                </IonCardContent>
              </IonCard>
            </IonCol>
            <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} size="6">
              <IonCard placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} className="home-card" routerLink="/PumpsMenu">
                <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                  <IonIcon placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} class="icon" icon={water} />
                  <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} class="icon-text-main">
                    Pumpar
                  </IonCardContent>
                </IonCardContent>
              </IonCard>
            </IonCol>
            <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} size="6">
              <IonCard placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} className="home-card" routerLink="/notes">
                <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                  <IonIcon placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} class="icon" icon={journal} />
                  <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} class="icon-text-main">
                    Anteckningar
                  </IonCardContent>
                </IonCardContent>
              </IonCard>
            </IonCol>
            <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} size="6">
              <IonCard placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} className="home-card" routerLink="/Purchase">
                <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                  <IonIcon placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} class="icon" icon={duplicate} />
                  <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} class="icon-text-main">
                    Skapa inköp
                  </IonCardContent>
                </IonCardContent>
              </IonCard>
            </IonCol>
            <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} size="6">
              <IonCard placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} className="home-card" routerLink="/stocktaking">
                <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                  <IonIcon placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} class="icon" icon={barcodeOutline} />
                  <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} class="icon-text-main">
                    Inventering
                  </IonCardContent>
                </IonCardContent>
              </IonCard>
            </IonCol>
            <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} size="6">
              <IonCard placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} className="home-card" routerLink="/WarehouseTransfer">
                <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                  <IonIcon placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} class="icon" icon={swapHorizontalOutline} />
                  <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} class="icon-text-main">
                    Lagerflytt
                  </IonCardContent>
                </IonCardContent>
              </IonCard>
            </IonCol>
            <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} size="6">
              <IonCard placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} className="home-card" routerLink="/IncomingGoods">
                <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                  <IonIcon placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} class="icon" icon={cubeOutline} />
                  <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} class="icon-text-main">
                    Följesedlar
                  </IonCardContent>
                </IonCardContent>
              </IonCard>
            </IonCol>
            <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} size="6">
              <IonCard placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} className="home-card" onClick={logout}>
                <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                  <IonIcon placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} class="icon" icon={logOut} />
                  <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} class="icon-text-main">
                    Logga ut
                  </IonCardContent>
                </IonCardContent>
              </IonCard>
            </IonCol>
            <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} size="6">
              <IonCard placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} className="home-card" routerLink="/settings">
                <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                  <IonIcon placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} class="icon" icon={settings} />
                  <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} class="icon-text-main">
                    Inställningar
                  </IonCardContent>
                </IonCardContent>
              </IonCard>
            </IonCol>
            {me?.developer && (
              <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} size="6">
                <IonCard placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} className="home-card" routerLink="/devsettings">
                  <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <IonIcon placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} class="icon" icon={construct} />
                    <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} class="icon-text-main">
                      Developer
                    </IonCardContent>
                  </IonCardContent>
                </IonCard>
              </IonCol>)}
          </IonRow>
        </IonGrid>

      </IonContent>
    </IonPage>
  );
};

export default Home;



